import { registerTour } from "../tourRegistry";
import { getDragDropAnimationHTML } from "../animations/DragDropAnimation";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'funds-overview',
      title: `Funds Overview <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Funds track how money is designated — restricted, unrestricted, building, missions, etc. Every transaction in T3 Books is assigned to a fund, making fund accounting seamless.',
      attachTo: { element: '[data-tour="funds-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'funds-rearrange',
      title: `Rearrange Funds <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: `Click the drag handle on any fund or group row to enter rearrange mode. Drag and drop to reorder funds and move them between groups — the order you set here is reflected in your reports.${getDragDropAnimationHTML()}`,
      attachTo: { element: '[data-tour="funds-fund-drag-handle"]', on: 'right' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'funds-add',
      title: `Add New Fund <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Click here to add a new fund. The form opens inline so you can set the name, number, and group without leaving the page.',
      attachTo: { element: '[data-tour="funds-add"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Open Form',
          classes: 't3-shepherd-next-btn',
          action() {
            const addBtn = document.querySelector('[data-tour="funds-add"]');
            if (addBtn) addBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            setTimeout(() => this.next(), 400);
          },
        },
      ],
    },
    {
      id: 'funds-sub-fund',
      title: `Sub Funds <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Toggle this on to make the new fund a <strong>sub fund</strong>. Sub funds nest under a parent fund — for example, a "Youth Missions" sub fund under "Missions". In reports, sub fund balances roll up into their parent\'s total.',
      attachTo: { element: '[data-tour="funds-sub-fund-toggle"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() {
            // Close the top-level form before moving on
            const addBtn = document.querySelector('[data-tour="funds-add"]');
            if (addBtn) addBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            setTimeout(() => this.next(), 400);
          },
        },
      ],
    },
    {
      id: 'funds-group-add',
      title: `Add to a Group <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'You can also add funds directly to a specific group using the <strong>+</strong> icon on the group header. This pre-fills the group for you. Click the pencil icon to rename a group.',
      attachTo: { element: '[data-tour="funds-group-add-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'funds-transfer',
      title: `Fund Transfers <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: "This is the fund transfer dialog. Select a source fund, destination fund, and amount to move between them — for example, when closing a temporary fund or reallocating money between programs. The transfer creates a journal entry automatically.",
      attachTo: { element: '[data-tour="funds-transfer-dialog"]', on: 'right' },
      beforeShowPromise() {
        window.dispatchEvent(new Event("tour:open-fund-transfer"));
        return new Promise((resolve) => setTimeout(resolve, 400));
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() {
            window.dispatchEvent(new Event("tour:close-fund-transfer"));
            setTimeout(() => this.back(), 300);
          },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() {
            window.dispatchEvent(new Event("tour:close-fund-transfer"));
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'funds-complete',
      title: `You're All Set! <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: 'That covers the essentials of Funds. Remember: fund order here controls report order, sub funds roll up into parents, and every transaction requires a fund assignment.',
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'funds',
  pathPattern: '/foundation/funds-list',
  getSteps,
  label: 'Funds Tour',
});
